export const mockData = {
  company: {
    name: 'Novatus Energie',
    fullName: 'NOVATUS Energie GmbH',
    tagline: 'Ihr Partner für energetische Modernisierung',
    description: 'Wir sind für Sie im Einsatz für die energetische Modernisierung von Ein- und Mehrfamilienhäusern durch den Einbau von Wärmepumpensystemen. Mit dem Einbau moderner Wärmepumpen kann man die Kosten für teure Dämmmaßnahmen enorm reduzieren!',
    phone: '+49 30 398205700',
    whatsapp: '+49 30 398205700',
    email: 'info@novatus-se.de',
    address: {
      street: 'Maximiliankorso 60',
      zip: '13465',
      city: 'Berlin'
    },
    legal: {
      ceo: 'Christof Schirm',
      court: 'Amtsgericht Charlottenburg',
      hrb: 'HRB 222 580',
      ustId: 'DE 296 655 515'
    }
  },
  
  partners: [
    { name: 'LG', logo: 'https://static.prod-images.emergentagent.com/jobs/37e58916-94c9-4c1a-acfe-799a909b33d1/images/7d9e5640d6382c8bc0ecd1936b2058efc93ca407090fa99d2b51130d880aecf5.png' },
    { name: 'Bosch', logo: 'https://static.prod-images.emergentagent.com/jobs/37e58916-94c9-4c1a-acfe-799a909b33d1/images/4a41f2ab5ef1c44eed3652b39b9d686190a4084c2ec4d79a8b9d1d6bab9f6bc6.png' },
    { name: 'Daikin', logo: 'https://static.prod-images.emergentagent.com/jobs/37e58916-94c9-4c1a-acfe-799a909b33d1/images/fbc49b993353963b3422a2c897d5b4e6f41dde1bf5c182a3d204bb3126e042d5.png' },
    { name: 'Clausius', logo: 'https://static.prod-images.emergentagent.com/jobs/37e58916-94c9-4c1a-acfe-799a909b33d1/images/d37436d5858f0ab08b8291d81c411b500520d73d375fa742830b982ca19a3c99.png' },
    { name: 'Dualsun', logo: 'https://static.prod-images.emergentagent.com/jobs/37e58916-94c9-4c1a-acfe-799a909b33d1/images/242a1d04733f9522bd3ae00f8c3b17910b61993c6e5f430b5a03d2ce8ca39a40.png' },
    { name: 'Abora', logo: 'https://static.prod-images.emergentagent.com/jobs/37e58916-94c9-4c1a-acfe-799a909b33d1/images/ea24872026a7a841b155a10ec6e522e024a83c9117095f056884b1012c12e342.png' }
  ],

  stats: [
    { label: 'Anzahl an Partnern für Sie im Einsatz', value: '32+' },
    { label: 'Erfolgreich abgeschlossene Projekte', value: '262+' }
  ],

  features: [
    {
      title: 'Langjährige Erfahrung auch in Ihrer Nähe',
      description: 'Durch die Zusammenarbeit mit regionalen Fachunternehmen fokussieren wir uns als Partner des Fachhandwerks vollständig auf die energetische Modernisierung und den Einbau von modernen Wärmepumpensystemen.'
    },
    {
      title: 'Regional und digital für unsere Kunden im Einsatz',
      description: 'Durch unser gemischtes Team aus jung und alt arbeiten wir nicht nur sorgfältig und qualitativ, sondern sind schnell, einfach und digital für Sie erreichbar.'
    },
    {
      title: 'Hohe Qualität durch internationale Markenhersteller',
      description: 'Wir arbeiten ausschließlich mit renommierten Marken wie Daikin, LG und Bosch zusammen und bieten Ihnen dadurch verlässliche Technik!'
    }
  ],

  comparison: {
    traditional: [
      { title: 'Fehlende Innovation', description: 'Der klassische Meisterbetrieb ums Eck hat wenig Erfahrung mit Technologien wie der Wärmepumpe' },
      { title: 'Eingeschränkte Erreichbarkeit', description: 'Kleinere Betriebe sind oftmals ausgebucht und melden sich erst nach Wochen zurück' },
      { title: 'Automatisierte Betreuung', description: 'Größere Betriebe gehen oft nicht auf die Bedürfnisse einzelner Kunden ein' },
      { title: 'Abhängigkeit von Subfirmen', description: 'Große Betriebe setzen oft auf Subfirmen für die Installation wichtiger Teilleistungen' }
    ],
    modern: [
      { title: 'Fokus auf moderne Energiesysteme', description: 'Wir fokussieren uns auf moderne Technik, unsere Mitarbeiter haben bereits hunderte solcher Anlagen verbaut' },
      { title: 'Schnell und digital für Sie da', description: 'Unser Team antwortet schnell per Telefon und Email' },
      { title: 'Persönlicher Ansprechpartner', description: 'Unser Team sitzt in Berlin und kann Termine schnell und einfach koordinieren' },
      { title: 'Hohe Qualität', description: 'Wir arbeiten ausschließlich mit deutschen Handwerksmarken und eigens angestelltem Personal' }
    ]
  },

  services: [
    {
      title: 'Wärmepumpen und Energiemanager',
      image: 'https://customer-assets.emergentagent.com/job_novatus-next/artifacts/bktyz4vg_5A350CE0-3F96-4BF4-B5C4-4EB4576D1FD4.jpeg',
      items: [
        'Wärmepumpen der Marken Daikin, Bosch und LG - wir sind aber auch markenunabhängig',
        'Installation von Energiemanagern, um das Zusammenspiel aus PV und Wärmepumpe zu optimieren',
        'Wartung und Service der Wärmepumpe auch nach der Installation'
      ]
    },
    {
      title: 'Heizlastberechnung & Fördermittelberatung',
      image: 'https://static.prod-images.emergentagent.com/jobs/37e58916-94c9-4c1a-acfe-799a909b33d1/images/781134baf30223e682e20a4575b35f494f47b1e808495559a25ccb7ece0c4564.png',
      items: [
        'Durchführung einer Heizlastberechnung nach DIN 12831',
        'Berechnung des hydraulischen Abgleichs, um Energie einzusparen',
        'Beratung über Fördermittel und Hilfe bei der Antragstellung bei KfW und BAFA'
      ]
    },
    {
      title: 'Heizflächensanierung',
      image: 'https://static.prod-images.emergentagent.com/jobs/37e58916-94c9-4c1a-acfe-799a909b33d1/images/16c2e394a9e504d766f540a8a66e0e2fc74fd2e748d2c24de856cd0866aab880.png',
      items: [
        'Einbau von Fußbodenheizung im gesamten Haus oder in einzelnen Zimmer, wie dem Badezimmer',
        'Einbau von modernen Niedertemperatur- und Gebläseheizkörpern von Arbonia, Kampmann, Kermi und mehr',
        'Berechnung und Durchführung des Hydraulischen Abgleichs'
      ]
    }
  ],

  projects: [
    {
      title: 'PVT-Wärmepumpen-System in Frankfurt',
      image: 'https://customer-assets.emergentagent.com/job_novatus-next/artifacts/gpc2cdsj_1966604D-3279-4C8E-B7EC-DD4760C21748.jpeg',
      description: 'In der Nähe von Frankfurt wurde ein gasbeheiztes Einfamilienhaus mit einem hybriden Luft-PVT-Wärmepumpensystem umgerüstet. Das 160 m² große Haus verbrauchte zuvor circa 16.000 kWh Erdgas pro Jahr. Nach der Umrüstung benötigt es nur noch 3.600 kWh Strom, der größtenteils selbst produziert wird.',
      details: [
        '12 PVT-Hybrid-Kollektoren',
        'Sole-Wasser-Wärmepumpe von Clausius Classic',
        'Maximaler COP von 5,8 und Jahresarbeitszahl (JAZ) von 3,7',
        'Absolut lautloser Betrieb, da keine Außeneinheit'
      ]
    },
    {
      title: 'Einfamilienhaus Berlin',
      image: 'https://customer-assets.emergentagent.com/job_novatus-next/artifacts/dj9q9ydn_IMG_1984.jpeg',
      description: 'In Berlin-Hönow haben wir ein gasbeheiztes Einfamilienhaus mit 130 m² Wohnfläche auf ein hocheffizientes PVT-Wärmepumpensystem umgerüstet. Der Gasverbrauch von 11.500 kWh pro Jahr wurde auf nur 2.050 kWh Strom reduziert, welcher zum größten Teil selbst produziert wird.',
      details: [
        '12 PVT Hybridkollektoren abora aH72SK',
        'Sole/Wasser-Wärmepumpe Clausius Elite H mit max. COP von 5,6',
        'Jahresarbeitszahl (JAZ) von 4,2 für höchste Effizienz'
      ]
    },
    {
      title: 'Mehrfamilienhaus Langenfeld',
      image: 'https://customer-assets.emergentagent.com/job_novatus-next/artifacts/1eeazb1q_IMG_2780.jpeg',
      description: 'In der Nähe von Düsseldorf haben wir ein Mehrfamilienhaus mit 6 Wohneinheiten durch den Einbau einer Luft-Wasser-Wärmepumpe modernisiert. Aufgrund des geringen Geräuschpegels konnte die Wärmepumpe im rückwärtigen Bereich des Hauses auch in der Nähe von Balkonen angebracht werden. Die Anlage versorgt alle Wohnungen zuverlässig mit erneuerbaren Energien.',
      details: [
        '16 kW Luft-Wasser-Wärmepumpe von LG Therma V R32',
        'Hocheffiziente Wärmepumpe mit geringem Schalldruck',
        'Nachhaltige Energieversorgung für 6 Wohneinheiten',
        'Reduzierung des Energieverbrauchs um einen Faktor 3,8'
      ]
    },
    {
      title: 'Architektenhaus Stuttgart',
      image: 'https://customer-assets.emergentagent.com/job_novatus-next/artifacts/bktyz4vg_5A350CE0-3F96-4BF4-B5C4-4EB4576D1FD4.jpeg',
      description: 'Bei diesem Architektenhaus in der Nähe von Stuttgart bestand die Herausforderung darin, dass pro Jahr 8.500 Liter Heizöl verwendet wurden. Diese Herausforderung wurde durch den Einbau einer Kaskade von zwei LG Therma V R290 Monoblöcken realisiert. Damit ist es gelungen, den hohen fossilen Energiebedarf mit der Jahresarbeitszahl 3,8 zu reduzieren und umweltfreundlich zu gestalten.',
      details: [
        '32 kW Heizlast realisiert durch 2er-Kaskade LG Therma V R290',
        'Individuelle Anpassung auch bei hohen Heizlasten durch Luft-Wasser-Wärmepumpen',
        'Geringe Schalldruckpegel sorgen dafür, dass die Nachbarschaft auch in Wohngebieten nicht beeinträchtigt ist'
      ]
    }
  ],

  testimonials: [
    {
      name: 'Markus H.',
      location: 'Berlin',
      text: 'Schön mal einen Betrieb zu finden, bei welchem auch die praktische Umsetzung top funktioniert! Waren vom Erstkontakt bis zur endgültigen Realisierung sehr sehr zufrieden. Professionell, zuverlässig und hochwertig, und dann auch noch ein super Preis-Leistungs-Verhältnis.',
      image: 'https://images.unsplash.com/photo-1758686253692-2d6921de12dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxtYXR1cmUlMjBob21lb3duZXIlMjBjb3VwbGUlMjByZXRpcmVtZW50JTIwYWdlJTIwaGFwcHklMjBzbWlsaW5nfGVufDB8fHx8MTc3NTYzNzUyMHww&ixlib=rb-4.1.0&q=85'
    },
    {
      name: 'Maximilian Z.',
      location: 'Nürnberg',
      text: 'Wir haben die Dienstleistungen der Novatus Energie GmbH für unsere Immobilie in Anspruch genommen und sind rundum zufrieden.',
      image: 'https://images.pexels.com/photos/7224933/pexels-photo-7224933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
    },
    {
      name: 'Julia S.',
      location: 'Kassel',
      text: 'Alles hat mit Novatus Energie super geklappt. Von der Planung bis zur Installation war der Ablauf reibungslos. Das Team hat sauber und genau gearbeitet. Ich werde sie gerne wieder beauftragen!',
      image: 'https://images.unsplash.com/photo-1758686254593-7c4cd55b2621?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxzZW5pb3IlMjB3b21hbiUyMGhvbWVvd25lciUyMHNtaWxpbmclMjBhdXRoZW50aWN8ZW58MHx8fHwxNzc1NjM4MzE3fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      name: 'Bernhard B.',
      location: 'Hamburg',
      text: 'Auch wenn es nicht zur Umsetzung des Projekts kam, muss man einfach positiv erwähnen, wie gut die Kommunikation im Angebotserstellungsprozess lief. Da können viele SHK Betriebe noch dazulernen.',
      image: 'https://images.unsplash.com/photo-1738566061874-2160e9f4a064?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxtaWRkbGUlMjBhZ2VkJTIwcHJvZmVzc2lvbmFsJTIwYnVzaW5lc3NtYW4lMjBwb3J0cmFpdCUyMGF1dGhlbnRpY3xlbnwwfHx8fDE3NzU2Mzc1MjJ8MA&ixlib=rb-4.1.0&q=85'
    }
  ],

  blogPosts: [
    {
      title: 'Gebläseheizkörper: Effiziente Wärmeverteilung und Kühlung in Kombination mit Wärmepumpen',
      category: 'Heizkörper',
      image: 'https://images.unsplash.com/photo-1678616143792-77d4091e9bbc?q=85',
      link: 'https://www.klimeo.de/waermepumpe/wissen/funktionen-und-anwendung/allrounder-waermepumpe-kuehlen-und-heizen-in-einem-system'
    },
    {
      title: 'Die richtige Dimensionierung der Wärmepumpe – und warum sie auf keinen Fall zu groß sein darf',
      category: 'Wärmepumpe',
      image: 'https://images.unsplash.com/photo-1564164494009-3876b2d197f1?q=85',
      link: 'https://www.co2online.de/modernisieren-und-bauen/waermepumpe/nachteile-einer-zu-grossen-waermepumpe/'
    },
    {
      title: 'Die effizientesten Speichersysteme für Heizung und Warmwasser',
      category: 'Heizung',
      image: 'https://images.unsplash.com/photo-1695045752264-26cf29eb00e8?q=85',
      link: 'https://www.dein-heizungsbauer.de/ratgeber/bauen-sanieren/waermekapazitaet/'
    }
  ],

  faqs: [
    {
      question: 'Welche Leistungen bieten Sie an?',
      answer: 'Als Partner des Fachhandwerks vermitteln wir hochwertige Wärmepumpen-Lösungen für Privatkunden, gewerbliche Kunden und öffentliche Einrichtungen. Wir haben uns auf die energetische Modernisierung durch den Einbau moderner Wärmepumpensysteme und PV:T Technologie spezialisiert. Wir arbeiten dafür mit regionalen Fachunternehmen zusammen, die die Installation professionell durchführen. Unsere Kernkompetenz liegt in der Beratung, Planung und Koordination Ihres Projekts – von der Erstberatung über die Fördermittelbeantragung bis zur Inbetriebnahme.'
    },
    {
      question: 'Mit welchen Herstellern arbeiten Sie zusammen?',
      answer: 'Wir arbeiten mit renommierten internationalen Markenherstellern zusammen. Bei Wärmepumpen setzen wir vor allem auf die Fabrikate von Daikin, Bosch und LG. Wir sind jedoch markenunabhängig und wählen stets das System, das optimal zu Ihrem Gebäude und Ihren Anforderungen passt. Zusätzlich arbeiten wir mit führenden Herstellern im Bereich PV:T-Hybridkollektoren zusammen, wie Abora, Dualsun und Clausius.'
    },
    {
      question: 'Wie läuft ein Projekt ab nach Kontaktaufnahme?',
      answer: 'In einem ersten Gespräch möchten wir die Anforderungen für Ihr Bauvorhaben genau verstehen. Ob Heizungsmodernisierung, Wärmepumpeninstallation oder komplette energetische Sanierung – gemeinsam definieren wir die Projektziele. Danach koordinieren wir einen Termin vor Ort mit einem unserer erfahrenen Fachpartner, um die baulichen Gegebenheiten zu prüfen. Dabei werden wichtige Voraussetzungen erfasst und Fördermöglichkeiten geprüft. Auf Basis der Analyse erstellen wir ein transparentes Angebot. Wir beraten Sie zu verschiedenen Systemlösungen und staatlichen Förderungen und übernehmen die Antragstellung. Die Installation erfolgt durch qualifizierte regionale Fachunternehmen mit modernster Technik und hochwertigen Markenprodukten. Auch nach Installation bleiben wir Ihr Ansprechpartner für Wartung, Optimierung und Service.'
    },
    {
      question: 'Lohnt sich eine Wärmepumpe für uns?',
      answer: 'Ob sich eine Wärmepumpe lohnt, hängt von mehreren Faktoren ab: Gebäudezustand, Heizlast, vorhandene Heizflächen und Ihr Energieverbrauch. Besonders in gut gedämmten Häusern mit Fußbodenheizung arbeitet eine Wärmepumpe sehr effizient und kann Ihre Heizkosten deutlich senken. Aber auch in vielen Bestandsgebäuden ohne Fußbodenheizung ist der Einsatz oft sinnvoll – insbesondere, wenn eine Modernisierung oder ein Heizkesseltausch ansteht. Dank aktuell hoher staatlicher Förderungen ist die Wärmepumpe in vielen Fällen eine zukunftssichere und nachhaltige Lösung. Wir prüfen gerne individuell, ob eine Wärmepumpe in Ihrem Haus wirtschaftlich und technisch sinnvoll ist.'
    },
    {
      question: 'Welche Wärmepumpen vermittelt Novatus Energie?',
      answer: 'Wir vermitteln ausschließlich Wärmepumpen von renommierten Herstellern wie Daikin, Bosch und LG. Damit bieten wir unseren Kunden zuverlässige, effiziente und zukunftssichere Lösungen – vom modernen Einfamilienhaus bis zum sanierten Mehrfamilienhaus oder Gewerbeobjekt. Da wir markenunabhängig arbeiten, können wir stets die Wärmepumpe empfehlen, die optimal zu Ihrem Gebäude und Ihrem Energiebedarf passt. Die Installation erfolgt durch qualifizierte regionale Fachbetriebe, mit denen wir eng zusammenarbeiten.'
    },
    {
      question: 'Welche Vorteile bietet mir Novatus Energie gegenüber meinem lokalen Heizungsbauer?',
      answer: 'Als moderner Partner des Fachhandwerks kombinieren wir die Expertise regionaler Fachunternehmen mit unserem Spezialwissen für energieeffiziente Wärmepumpensysteme und PV:T Technologie. Wir bieten Ihnen einen umfassenden Service: schnelle und digitale Erreichbarkeit, persönliche Beratung, Koordination aller Gewerke, Unterstützung bei Fördermitteln und eine zentrale Ansprechperson für Ihr gesamtes Projekt. So verbinden wir regionale Handwerksqualität mit moderner, effizienter Projektabwicklung – und das deutschlandweit.'
    }
  ]
};